import React, { useEffect, useRef, useState } from 'react'
import { Column } from 'primereact/column'
import IbsCstService from './ibsCstService'
import FormList from 'base/FormList'

export default function IbsCstList() {

    const [service] = useState(() => new IbsCstService())
    const toast = useRef(null)
    const searchData = {
        pkName: 'codigo_ibscst',
        dsName: 'descricao_ibscst',
        mainField: { name: 'descricao_ibscst', label: 'Descrição' },
        advFields: [
            { name: 'codigo_ibscst', label: 'Código', type: 'string', inputMode: 'text' },
            { name: 'descricao_ibscst', label: 'Descrição', type: 'string', inputMode: 'text' },
        ]
    }

    useEffect(() => {
    }, [service])

    return (
        <FormList service={service} toast={toast} searchData={searchData} showActions={true}>
            <Column field="codigo_ibscst" sortable header="Código"></Column>
            <Column field="descricao_ibscst" sortable header="Descrição"></Column>
        </FormList>
    )
}
